import JassEnum from './enum';

/**
 * type soundtype
 */
export default class JassSoundType extends JassEnum {}
